module.exports = __webpack_public_path__ + "img/instruction-bg.png";